export default __webpack_public_path__ + "static/flag-be-e14982ab4565e9247b38d52f7497788f.svg";